export default __webpack_public_path__ + "static/media/templates_import.92d116be.zip";